import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';
import SlideShow from './Slideshow';
import { Buffer } from 'buffer';
import { replaceCredentials } from '../../../utils';
window.Buffer = Buffer;

/**
 * Plays the learn video shown at the start of each day.
 */
export default function Learn({
  background,
  module,
  setDisplayLearn,
  slidesConfig,
  step_completed,
  video,
  login,
  moduleName,
  onClose,
  openPhotoTime,
}) {
  const dispatch = useDispatch();

  const [displayLearnVideo, setDisplayLearnVideo] = useState(true);
  const [displaySlideShow, setDisplaySlideShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');

  const getVideoLink = useCallback(async () => {
    const link = replaceCredentials(
      video,
      module.StudentID,
      login.influencerid
    );
    setVideoUrl(link);
    setDisplayLearnVideo(!!video);
  }, [login.influencerid, module.StudentID, video]);

  useEffect(() => {
    getVideoLink();
  }, [video, getVideoLink]);

  const handleStepCompleted = () => {
    if (!module.reviewIcon) {
      dispatch({ type: step_completed, payload: 'learn' });
    }
    module.sectionCompleted = module.sectionCompleted + 1
    setDisplayLearn(false);
  };

  const handleLearnVideoClose = () => {
    setDisplaySlideShow(true);
    setDisplayLearnVideo(false);
  };

  const handleCloseClick = () => {
    setDisplayLearnVideo(false);
    setDisplaySlideShow(false);
    onClose();
  };

  // The actual HTML code telling the world module to show the learn video
  return (
    <div
      className='slideshow-container'
      style={{ backgroundImage: `url(${background})` }}
    >
      {displayLearnVideo && videoUrl && (
        <CloudfrontVideoFormat
          source={videoUrl}
          background={background}
          close={handleCloseClick}
          ended={handleLearnVideoClose}
        />
      )}

      {displaySlideShow && (
        <SlideShow
          background={background}
          navigate={slidesConfig.navigate}
          song={slidesConfig.song}
          recording={slidesConfig.recording}
          jsonUrl={slidesConfig.json}
          module={module}
          moduleName={moduleName}
          onClose={handleStepCompleted}
          onCloseBtnClick={handleCloseClick}
          openPhotoTime={openPhotoTime} 
        />
      )}
    </div>
  );
}
